import React from "react";
export function Author() {
  return <section className="bg-white px-5 py-12" data-id="element-19" data-mp="cc8s9w3ap1l8">
      <div className="mx-auto max-w-md" data-id="element-20" data-mp="oi1kfwtqtkdu">
        <div className="rounded-3xl bg-navy-800 p-6 text-white sm:p-8" data-id="element-21" data-mp="oj49s0bf3ern">
          <h2 className="font-display text-xl font-extrabold sm:text-2xl" data-id="element-22" data-mp="9tycwj01y0mx">🦷 Sobre la Dra. Karito</h2>
          <div className="mt-4 space-y-3 text-sm leading-relaxed text-white/75" data-id="element-23" data-mp="esrscgywg1pq">
            <p data-id="element-24" data-mp="12hazgt67q8g8">
              Después de trabajar con cientos de tratamientos con alineadores, la Dra. Karito
              identificó un patrón que se repetía constantemente.
            </p>
            <p data-id="element-25" data-mp="sjwkyz3untqk">
              Muchos refinamientos no aparecían por mala suerte.{" "}
              <strong className="text-white" data-id="element-26" data-mp="xi7vlc1yy89u">Comenzaban mucho antes:</strong> en pequeños errores
              durante el diagnóstico, en decisiones tomadas durante la planificación, en movimientos
              biomecánicamente poco predecibles y en detalles que normalmente pasan desapercibidos
              cuando se aprueba un setup.
            </p>
            <p data-id="element-27" data-mp="1tz3o0kv2ezgi">
              Por eso desarrolló el{" "}
              <strong className="text-brand-light" data-id="element-28" data-mp="1p00o1etxzjfe">Sistema Antirrefinamientos™</strong>: una
              biblioteca clínica diseñada para consultar protocolos rápidamente y ayudar a tomar
              decisiones con mayor criterio clínico antes, durante y al finalizar un tratamiento.
            </p>
          </div>
        </div>
      </div>
    </section>;
}